// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 714 ? "11a89e4f" : chunkId) + "." + {"625":"495c23aa77ffca8c","714":"6435fc8c154845f4","829":"fac1ee1b0cdf8ec2"}[chunkId] + ".js";
};